const ACTIONTYPE_ADDRESS = {
  GET_FCC_DETAILS: 'GET_FCC_DETAILS',
  GET_FCC_DETAILS_SUCCESS: 'GET_FCC_DETAILS_SUCCESS',
  GET_FCC_DETAILS_ERROR: 'GET_FCC_DETAILS_ERROR',

  GET_FCC_PROSPECT_PLANS: 'GET_FCC_PROSPECT_PLANS',
  GET_FCC_PROSPECT_PLANS_SUCCESS: 'GET_FCC_PROSPECT_PLANS_SUCCESS',
  GET_FCC_PROSPECT_PLANS_ERROR: 'GET_FCC_PROSPECT_PLANS_ERROR',

  MAKE_RETRIEVE_ZIPCODE_CALL: 'MAKE_RETRIEVE_ZIPCODE_CALL',
  MAKE_RETRIEVE_ZIPCODE_CALL_SUCCESS: 'MAKE_RETRIEVE_ZIPCODE_CALL_SUCCESS',
  MAKE_RETRIEVE_ZIPCODE_CALL_ERROR: 'MAKE_RETRIEVE_ZIPCODE_CALL_ERROR',

  NEW_BROWSING_API_CALL: 'NEW_BROWSING_API_CALL',
  NEW_BROWSING_API_CALL_SUCCESS: 'NEW_BROWSING_API_CALL_SUCCESS',
  NEW_BROWSING_API_CALL_ERROR: 'NEW_BROWSING_API_CALL_ERROR',

  UPDATE_TAX_DETAILS: 'UPDATE_TAX_DETAILS',

  GET_ADDRESS_LIST_DETAILS: 'GET_ADDRESS_LIST_DETAILS',
  SHOW_ERROR_MESSAGE: 'SHOW_ERROR_MESSAGE',
  RESET_ERROR_MESSAGE: 'RESET_ERROR_MESSAGE',
  RESTORE_DEFAULT_ADDRESS_STATE: 'RESTORE_DEFAULT_ADDRESS_STATE',
  UPDATE_PARSED_ADDRESS: 'UPDATE_PARSED_ADDRESS',
  UPDATE_USER_TYPED_ADDRESS: 'UPDATE_USER_TYPED_ADDRESS',
  UPDATE_CONTINUE_BUTTON_STATUS: 'UPDATE_CONTINUE_BUTTON_STATUS',
  STORE_USER_SELECTED_ADDRESS: 'STORE_USER_SELECTED_ADDRESS',
};

export default ACTIONTYPE_ADDRESS;
